import { render, staticRenderFns } from "./PurchaseReturnView.vue?vue&type=template&id=5e0bc49b"
import script from "./PurchaseReturnView.vue?vue&type=script&lang=js"
export * from "./PurchaseReturnView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports